import React, { Fragment, useCallback } from 'react';
import { Text } from 'roo-ui/components';
import Modal from 'components/Modal';
import TextButton from 'components/TextButton';
import { useModal } from 'lib/hooks';
import { useDataLayer } from 'hooks/useDataLayer';

const QFFInformation = () => {
  const { openModal, modalProps } = useModal();
  const { emitInteractionEvent } = useDataLayer();
  const handleOnClick = useCallback(() => {
    openModal();
    emitInteractionEvent({ type: 'QFF Earn Points', value: 'Points FAQ Link Selected' });
  }, [openModal, emitInteractionEvent]);

  return (
    <Fragment>
      <TextButton
        color="greys.steel"
        hoverColor="greys.steel"
        textDecoration="underline"
        onClick={handleOnClick}
        py={[0, 1]}
        data-testid="qff-link"
        fontSize="sm"
      >
        When will I get my points?
      </TextButton>
      {modalProps.isOpen && (
        <Modal {...modalProps} padding="0" title="Earn Qantas Points">
          <Text display="block" p={6}>
            Qantas Points will automatically be credited within 8 weeks of checkout if the name and number match the details in the Frequent
            Flyer account.
          </Text>
        </Modal>
      )}
    </Fragment>
  );
};

export default QFFInformation;
